import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//
import {
  changeEarningType,
  getEarnings,
} from "../../../redux/features/user/actions";

//
import { Form } from "react-bootstrap";

//
import TitleBox from "../TitleBox";
import BoxLoading from "../../general/BoxLoading";
import NothingToShow from "../../general/NothingToShow";
import DesktopEarningList from "./earning/DesktopEarningList";
import MobileEarningList from "./earning/MobileEarningList";

function Earnings({ windowSize, user, plan, changeEarningType }) {
  const [loading, setLoading] = useState(false);
  const [earnings, setEarnings] = useState([]);

  const [earningSwitch, setEarningSwitch] = useState(false);

  const changeEarning = (e) => {
    setEarningSwitch(e.target.checked);

    // set variable
    let type = earningSwitch ? "point" : "fiat";

    // request
    changeEarningType({ type });
  };

  const setReferralType = () => {
    let type = user.referral_type;

    setEarningSwitch(type === "point" ? false : true);
  };

  /**
   * Get Earnings
   */
  const get_earnings = () => {
    // start loading
    setLoading(true);

    // request
    getEarnings().then((res) => {
      if (res) {
        setLoading(false);
        setEarnings(res);
      } else {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    get_earnings();
    setReferralType();

    // eslint-disable-next-line
  }, []);

  return (
    <div className="earning position-relative">
      <TitleBox
        title="Earnings"
        subject="List of your earnings from referrals"
      />

      <Form.Check
        type="switch"
        id="custom-switch"
        label={`Gain from referrals: ${earningSwitch ? "Fiat" : "Point"}`}
        onChange={changeEarning}
        checked={earningSwitch}
        disabled={!plan}
      />

      {earnings.length ? (
        <>
          {windowSize > 576 ? (
            <DesktopEarningList items={earnings} />
          ) : (
            <MobileEarningList items={earnings} />
          )}
        </>
      ) : (
        <NothingToShow text={loading ? "Loading..." : "Nothing to show"} />
      )}

      {loading && <BoxLoading />}
    </div>
  );
}

Earnings.propTypes = {
  windowSize: PropTypes.number.isRequired,
  user: PropTypes.object.isRequired,
  plan: PropTypes.object,
  changeEarningType: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  changeEarningType,
};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
  user: state.userReducer.user,
  plan: state.userReducer.plan,
});

export default connect(mapStateToProps, mapDispatchToProps)(Earnings);
